export const TERMS_CATEGORIES = ['terms_of_service', 'privacy_policy', 'feed_guidelines', 'marketing_consent', 'refund_exchange_policy']